module.exports = __webpack_public_path__ + "media/recipes/105-986ca9a0.png";